import React from 'react';
import styles from './UIGamePlayerInfoFooter.module.scss';
import clsx from 'clsx';
import { Timer } from '../../../common/Timer/Timer.tsx';
import { T } from '@colonist/ui';
import { useTimerLowTime } from '../../../hooks/useTimerLowTime.ts';
import { RED_TIMER_AND_TICKING_SOUND_THRESHOLD } from '@colonist/utils';
export const UIGamePlayerInfoFooter = ({ text, timeLeftInSeconds, isLowTimeEnabled = true, hideTimer = false, hideText = false })=>{
    const isRedAndTicking = isLowTimeEnabled && timeLeftInSeconds <= RED_TIMER_AND_TICKING_SOUND_THRESHOLD;
    useTimerLowTime(timeLeftInSeconds, isRedAndTicking);
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, !hideText && /*#__PURE__*/ React.createElement("div", {
        className: styles.text
    }, /*#__PURE__*/ React.createElement(T, {
        id: text
    })), !hideTimer && /*#__PURE__*/ React.createElement(Timer, {
        className: clsx(styles.time, {
            [styles.lowTime]: isRedAndTicking
        }),
        timeLeftInSeconds: timeLeftInSeconds
    }));
};
